import Tacos from "./assets/breakfast1.jpg"
import Porridge from "./assets/breakfast2.jpg"
import TacPretzelsos from "./assets/breakfast3.jpg"
import Croissant from "./assets/breakfast4.jpg"
import Lasagna from "./assets/launch1.jpg"
import Crostini from "./assets/launch2.jpg"
import Caesar from "./assets/launch3.jpg"
import Fish from "./assets/launch4.jpg"
import Chicken from "./assets/dinner1.jpg"
import Enchilada from "./assets/dinner2.jpg"
import Ham from "./assets/dinner3.jpg"
import Bruschetta from "./assets/dinner4.jpg"


export const data = [
    {
        id: 1,
        title: "Breakfast Tacos",
        content: `InstructionsIngredients Breakfast Tacos might be just the Mexican recipe you are searching for. One serving 
        contains 367 calories, 17g of protein, and 16g of fat. For 92 cents per serving, this recipe  covers 16% of your daily
        requirements of vitamins and minerals. It works best as a main course, and is done in roughly 45 minutes. This recipe
        is liked by 1 foodies and cooks. If you have salt & pepper, cheddar cheese, eggs, and a few other ingredients on hand, 
        you can make it. To use up the eggs you could follow this main course with the Rose Levy Beranbaum's Chocolate Tomato 
        Cake with Mystery Ganache as a dessert. All things considered, we decided this recipe deserves a spoonacular score of 
        42%. This score is solid. Try Tacos paran el Desayuno (Breakfast Tacos), Breakfast Tacos, and Breakfast Tacos for 
        similar recipes.`,
        img: Tacos,
        type: "Breakfast",
        price:"36.6$"
    },
    {
        id: 2,
        title: "Prune Breakfast Bread",
        content: `The recipe Prune Breakfast Bread can be made in approximately 1 hour and 20 minutes. This recipe 
        serves 8. One serving contains 301 calories, 5g of protein, and 4g of fat. For 45 cents per serving, this 
        recipe covers 8% of your daily requirements of vitamins and minerals. 1 person were impressed by this recipe. 
        It is a good option if you're following a dairy free and lacto ovo vegetarian diet. `,
        img: Porridge,
        type: "Breakfast",
        price:"85.6$"
    },
    {
        id: 3,
        title: "Sunny Fruit Parfait",
        content: `This recipe makes 1 servings with 128 calories, 1g of protein, and 1g of fat each. For 42 cents per 
        serving, this recipe covers 3% of your daily requirements of vitamins and minerals. A few people made this recipe, 
        and 93 would say it hit the spot. A mixture of yogurt, raisins, sunflower seeds, and a handful of other ingredients 
        are all it takes to make this recipe so tasty. `,
        img: TacPretzelsos,
        type: "Breakfast",
    },
    {
        id: 4,
        title: "Redneck Breakfast on a Croissant",
        content: `Redneck Breakfast on a Croissant takes roughly about 45 minutes from beginning to end. This breakfast
        has 368 calories, 14g of protein, and 22g of fat per serving. This recipe serves 1. For $1.56 per serving, 
        this recipe covers 12% of your daily requirements of vitamins and minerals. 1 person were glad they tried
        this recipe. It is brought to you by Foodista. Head to the store and pick up kosher salt and pepper, 
        corned beef hash, butter, and a few other`,
        img: Croissant,
        type: "Breakfast",
        price:"69$"
    },

    {
        id: 5,
        title: "Simple Skillet Lasagna",
        content: `Simple Skillet Lasagna might be just the main course you are searching for. This recipe makes 5 
        servings with 814 calories, 34g of protein, and 46g of fat each. For $2.47 per serving, this recipe covers 
        35% of your daily requirements of vitamins and minerals. 231 person have tried and liked this recipe. If 
        you have pepper flakes, onion, oregano flakes, and a few other ingredients on hand, you can make it. `,
        img: Lasagna,
        type: "Launch",
        price:"16.6$"
    },
    {
        id: 6,
        title: "Mushroom Hummus Crostini",
        content: `The recipe Mushroom Hummus Crostini can be made in about 30 minutes. For $2.41 per serving, 
        this recipe covers 31% of your daily requirements of vitamins and minerals. One serving contains 468 
        calories, 21g of protein, and 10g of fat. This recipe serves 4. 1 person were impressed by this recipe. 
        It works well as a rather inexpensive hor d'oeuvre. A mixture of lemon juice, hummus,`,
        img: Crostini,
        type: "Launch",
        price:"18.96$"
    },
    {
        id: 7,
        title: "Salmon Caesar Salad",
        content: `Salmon Caesar Salad might be just the main course you are searching for. This gluten free, 
        primal, fodmap friendly, and pescatarian recipe serves 2 and costs $3.01 per serving. One serving contains 
        393 calories, 27g of protein, and 29g of fat. Only a few people made this recipe, and 7 would say it hit the spot.
        A mixture of caesar dressing, romaine, slivered almonds`,
        img: Caesar,
        type: "Launch",
        price:"96.8$"
    },
    {
        id: 8,
        title: "Thai Fish Cakes",
        content: `The recipe Thai Fish Cakes could satisfy your Asian craving in approximately 45 minutes. This main 
        course has 501 calories, 44g of protein, and 22g of fat per serving. For $6.42 per serving, this recipe covers 
        54% of your daily requirements of vitamins and minerals. 1 person were impressed by this recipe. If you have
        curry paste, chilli, egg, and a few other ingredients on hand, you can make it.`,
        img: Fish,
        type: "Launch",
        price:"105.8$"
    },

    {
        id: 9,
        title: "Whole Chicken Dinner",
        content: `Need a gluten free, dairy free, and whole 30 main course? Whole Chicken Dinner could be a tremendous 
        recipe to try. This recipe serves 3 and costs $5.3 per serving. One portion of this dish contains roughly 72g of 
        protein, 61g of fat, and a total of 1106 calories. 1 person has made this recipe and would make it again.`,
        img: Chicken,
        type: "Dinner",
    },
    {
        id: 10,
        title: "Skillet Enchilada Dinner",
        content: `The recipe Skillet Enchilada Dinner could satisfy your Mexican craving in roughly 40 minutes. One 
        serving contains 334 calories, 35g of protein, and 9g of fat. This recipe serves 4 and costs $2.88 per serving. 
        It is a good option if you're following a gluten free diet. Not a lot of people made this recipe,`,
        img: Enchilada,
        type: "Dinner",
        price:"48$"
    },
    {
        id: 11,
        title: "Grilled Ham",
        content: `The recipe Grilled Ham and Cheese French Toast For A Quick Weeknight Dinner can be made in 
        approximately approximately 45 minutes. One serving contains 429 calories, 32g of protein, and 21g of fat. 
        For $1.42 per serving, this recipe covers 22% of your daily requirements of vitamins and minerals. This recipe 
        serves 4. 3 people were glad they tried this recipe..`,
        img: Ham,
        type: "Dinner",
        price:"22$"
    },
    {
        id: 12,
        title: "Bruschetta Style",
        content: `You can never have too many main course recipes, so give What to make for dinner tonight?? Bruschetta 
        Style Pork & Pastan a try. For $1.45 per serving, this recipe covers 22% of your daily requirements of vitamins 
        and minerals. This recipe makes 5 servings with 521 calories, 35g of protein, and 10g of fat each. 163 people 
        have tried and liked this recipe. If you have bow tie pasta, pork chops, recipe makers chicken bruschetta pasta`,
        img: Bruschetta,
        type: "Dinner",
        price:"45$"
    },
]